<template lang="pug">
  div.conversaBtn.btn-link(@click="showConversa()")
    StaticContent(v-if="banner" resource="conversa" data-cy="conversa-banner")
    template(v-else)
      div.conversa_collapsed_button.ml-1(v-if="floating")
        a(
          href="#",
          class="hvr-grow",
          v-bind="trackFloatingButton",
          data-cy="conversa-floating-button",
          :title="floatingButtonTitle"
        )
          img(:src="getImgUrl('ico_sofia30.png')" class="conversa_collapsed_button__icoFloatConversa")
      div.conversa_expanded_button(v-else)
        a(href="#", class="w-100 hvr-shrink")
          .conversa__container
            div(v-if="current_user_materia" class="d-flex flex-row justify-content-center align-items-center")
              img(:src="getImgUrl('logo_Conversa_Color_Part.png')" class="conversa__logoConversa--ico--Part")
              div.conversa__titleMateria
                p.m-0(v-if="current_user_materia" :class="['conversa__titleMateria__text', formattedMateria]") {{ renderMateria }}
            img(v-else :src="getImgUrl('logo_Conversa_Color.png')" class="conversa__logoConversa--ico")
</template>

<script>
import { mapMutations } from 'vuex'
import mixins from 'common/mixins'
import StaticContent from 'components/StaticContent.vue'

export default {
  name: 'conversa-button-vue',
  components: { StaticContent },
  mixins: [mixins.translate],
  props: {
    floating: { type: Boolean, default: true },
    banner:   { type: Boolean, default: false },
    bannerImage: { type: String, default: 'BannerConversa.png' },
    current_user_materia: { type: String, default: '' },
    statsEnabled: { type: Boolean, default: false },
    trackSource: { type: String, default: '' }
  },
  computed: {
    floatingButtonTitle() {
      return this.t('floating_buttons.conversa')
    },
    formattedMateria() {
      return this.current_user_materia
        ? this.current_user_materia
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '_')
            .toLowerCase()
        : '';
      },
    renderMateria() {
      return this.current_user_materia || ''
    },
    trackFloatingButton() {
      if (!this.statsEnabled) return null

      return {
        'data-track-category': this.trackValue('tracking.floating.category'),
        'data-track-action': this.trackValue('tracking.floating.conversa'),
        'data-track-name': this.trackValue('floating_buttons.conversa'),
        'data-track-source': this.trackSource
      }
    }
  },
  methods: {
    ...mapMutations('conversa', ['setShowConversa']),
    showConversa() {
      this.setShowConversa(true)
    },
    getImgUrl(imgName) {
      return require('../../../assets/images/conversa/' + imgName)
    },
    trackValue(valueId) {
      return this.t(valueId, { locale: 'es' })
    }
  },
  mounted() {
    if(localStorage.getItem('start_conversa') == 'true') {
      localStorage.removeItem('start_conversa')
      this.showConversa()
    }
  }
}
</script>
